<div class="heading-section">{{ 'documents.questions.create' | translate }}</div>
<lms-question-editor (onSave)="onSave($event)" [clientId]="clientId" [documentId]="documentId">
  <a class="lms-question-create" (click)="cancel()" form-actions-before>{{ 'actions.cancel' | translate }}</a>
</lms-question-editor>
